import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "wc-order-type-cart-option" }
const _hoisted_2 = { class: "wc-order-type-cart-option__info" }
const _hoisted_3 = { class: "wc-order-type-cart-option__name" }
const _hoisted_4 = {
  key: 0,
  class: "wc-order-type-cart-option__current"
}
const _hoisted_5 = {
  key: 1,
  class: "wc-order-type-cart-option__new"
}

import { computed, inject } from 'vue';
import WCImage from '@/components/WCImage/WCImage.vue';
import WCAddToCartQuantityAdjusterModernCard from '@/modules/cart/components/WCAddToCartQuantityAdjusterModernCard/WCAddToCartQuantityAdjusterModernCard.vue';
import useOrderTypes from '@/composables/useOrderTypes';
import { configurationKey } from '@/injections';
import { store } from '@/store';
import ItemSummary from '@/models/entities/items/item-summary';
import OrderType from '@/models/entities/cart/order-type';


export default /*@__PURE__*/_defineComponent({
  __name: 'WCOrderTypeCartOption',
  props: {
    item: {},
    orderType: {},
    variation: {}
  },
  setup(__props: any) {

const props = __props;

const configuration = inject(configurationKey);
const { activeOrderType } = useOrderTypes();

const isCurrent = computed(() => props.orderType.id === activeOrderType.value?.id);

const imageSrc = computed(() => `${configuration?.cdn}/api/img/${props.orderType.image}`);

const nonEmptyCartOrderTypeIds = computed<string[]>(
  () =>
    store.getters['cart/nonEmptyCarts']?.map((cart: { orderType: string }) => cart.orderType) ?? [],
);

const isNewCart = computed(
  () => !isCurrent.value && !nonEmptyCartOrderTypeIds.value.includes(props.orderType.id),
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createVNode(WCImage, {
      imageSrc: imageSrc.value,
      imageAlt: _ctx.orderType.name,
      defaultIcon: "basket-shopping",
      class: "wc-order-type-cart-option__icon"
    }, null, 8, ["imageSrc", "imageAlt"]),
    _cache[1] || (_cache[1] = _createTextVNode()),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.orderType.name) + " ", 1),
        (isCurrent.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('current')), 1))
          : _createCommentVNode("", true),
        _cache[0] || (_cache[0] = _createTextVNode()),
        (isNewCart.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('newCart')), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _cache[2] || (_cache[2] = _createTextVNode()),
    _createVNode(WCAddToCartQuantityAdjusterModernCard, {
      class: "wc-order-type-cart-option__control",
      item: _ctx.item,
      orderType: _ctx.orderType,
      variation: _ctx.variation
    }, {
      "atc-label": _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('add')), 1)
      ]),
      _: 1
    }, 8, ["item", "orderType", "variation"])
  ]))
}
}

})